module.exports = __webpack_public_path__ + "static/img/15.7be5f98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/15.png
// module id = 35j8
// module chunks = 35